// import {
//   FETCH_HOTEL_FAILURE,
//   FETCH_HOTEL_REQUEST,
//   FETCH_HOTEL_SUCCESS,
// } from "./hotelActionTypes";

// const initialState = {
//   hotelDatas: [],
//   loading: false,
//   error: null,
// };

// const hotelReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case FETCH_HOTEL_REQUEST:
//       return {
//         ...state,
//         loading: true,
//         error: null,
//       };
//     case FETCH_HOTEL_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         error: null,
//         hotelDatas: action.payload.data,
//       };
//     case FETCH_HOTEL_FAILURE:
//       return {
//         ...state,
//         hotelDatas:[],
//         loading: false,
//         error: action.payload,
//       };
//     default:
//       return state;
//   }
// };

// export default hotelReducer;
import {
  FETCH_HOTEL_REQUEST,
  FETCH_HOTEL_SUCCESS,
  FETCH_HOTEL_FAILURE,
  CREATE_HOTEL_REQUEST,
  CREATE_HOTEL_SUCCESS,
  CREATE_HOTEL_FAILURE,
  UPDATE_HOTEL_REQUEST,
  UPDATE_HOTEL_SUCCESS,
  UPDATE_HOTEL_FAILURE,
  DELETE_HOTEL_REQUEST,
  DELETE_HOTEL_SUCCESS,
  DELETE_HOTEL_FAILURE,
} from "./hotelActionTypes";

const initialState = {
  hotelDatas: [],
  loading: false,
  error: null,
};

const hotelReducer = (state = initialState, action) => {
  switch (action.type) {
    // FETCH
    case FETCH_HOTEL_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_HOTEL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        hotelDatas: action.payload.data,
      };
    case FETCH_HOTEL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        hotelDatas: [],
      };

    // CREATE
    case CREATE_HOTEL_REQUEST:
      return { ...state, loading: true, error: null };
    case CREATE_HOTEL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        hotelDatas: action.payload.data,
      };
    case CREATE_HOTEL_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // UPDATE
    case UPDATE_HOTEL_REQUEST:
      return { ...state, loading: true, error: null };
    case UPDATE_HOTEL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        hotelDatas: action.payload.data,
      };
    case UPDATE_HOTEL_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // DELETE
    case DELETE_HOTEL_REQUEST:
      return { ...state, loading: true, error: null };
    case DELETE_HOTEL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        hotelDatas: action.payload.data,
      };
    case DELETE_HOTEL_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default hotelReducer;
